import "./AutomotiveManufacturingSuccessCase.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Automotivesprayingsolutions from "./sections/Automotivesprayingsolutions";
import Metrics from "./sections/Metrics";
import ContactConsultation from "./sections/ContactConsultation";
import Footer from "@/reusable_sections/Footer";
export default function AutomotiveManufacturingSuccessCasePage() {
  return <div>
      <Header />
      <Hero />
      <Automotivesprayingsolutions />
      <Metrics />
      <ContactConsultation />
      <Footer />
    </div>;
}